const volunteerText = `
===============
AS A VOLUNTEER
===============

I spent 3 years (2023–2025) as the vice-president of a small association, ANT, which stands for Accessibilité Numérique pour Tous (Digital Accessibility for All).
During this time, I acted as both a teacher and the go-to person for elders who needed help understanding and using digital tools. I organized workshops on basic computer skills, online safety, and smartphone use, adapting my explanations to each person’s pace and needs. This experience taught me patience, empathy, pedagogy, and the importance of clear communication. 
I also improved the confidence I had from my 11 years of theater, confidence in public speaking and leadership through coordinating volunteers and planning events. Above all, I learned how small actions like helping someone send their first email or video call their family can make a real difference in people’s lives.
This experience really changed me, I'm now convinced that I'll be a volunteering for the rest of my life, to give my time and energy to help others.

If you wish there is an article about this that can be found in the start menu : Favorites -> My volunteering Article (French) :p
`;

export default volunteerText;
